import { render, staticRenderFns } from "./quotationManagement.vue?vue&type=template&id=507db8a4&scoped=true"
import script from "./quotationManagement.vue?vue&type=script&lang=js"
export * from "./quotationManagement.vue?vue&type=script&lang=js"
import style0 from "./quotationManagement.vue?vue&type=style&index=0&id=507db8a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507db8a4",
  null
  
)

export default component.exports